import React, { ReactNode } from "react";

import { Checkbox, CheckboxProps, TypographyProps } from "@mui/material";

/**
 * @see Checkbox
 */
export const IgCheckbox = (props: CheckboxProps) => {
  return <Checkbox {...props} />;
};
